<template>
    <div v-if="activeExportInvoice && activeExportInvoice.transports" class="pa-5 compact-form">
        <div
            v-for="(item, index) in activeExportInvoice.transports"
            v-if="activeExportInvoice.transports.length > 0"
            :key="`export_invoice_transport_${item.id}_${index}`"
        >
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Delivery date" | t }}</v-col>
                <v-col cols="6" class="mb-1">
                    <v-menu
                        v-model="item.show_date_from_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formatDate(item.delivery_date)"
                                append-icon="fas fa-calendar"
                                readonly
                                outlined
                                hide-details
                                dense
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            first-day-of-week="1"
                            v-model="item.delivery_date"
                            @input="item.show_date_from_menu = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Terms of delivery" | t }}</v-col>
                <v-col cols="6">
                    <v-select
                        :value="item.terms_of_delivery"
                        @input="updateTransportField($event, 'terms_of_delivery', index)"
                        :placeholder="t('Terms of delivery')"
                        :items="termsOfDeliveryItems"
                        class="text-field-item mb-1"
                        dense
                        item-text="title"
                        item-value="value"
                        hide-details
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Cargo type" | t }}</v-col>
                <v-col cols="6">
                    <v-select
                        :value="item.cargo_type"
                        @input="updateTransportField($event, 'cargo_type', index)"
                        :placeholder="t('Cargo type')"
                        :items="cargoTypeItems"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        item-text="title"
                        item-value="value"
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Carrier company" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.carrier_company"
                        @input="updateTransportField($event, 'carrier_company', index)"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Additional terms" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.additional_terms"
                        @input="updateTransportField($event, 'additional_terms', index)"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
                <v-col style="text-align:right;">
                    <v-btn
                        small
                        class="px-2 mt-2"
                        color="bal-red"
                        dark
                        style="min-width: 0;"
                        @click.stop="removeActiveExportInvoiceTransportRow"
                    >
                        <v-icon small>fal fa-trash-alt</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-divider class="my-2" />
        </div>
        <v-row>
            <v-col style="text-align:right;">
                <v-btn
                    small
                    class="px-2 ml-2"
                    color="bal-red"
                    dark
                    style="min-width: 0;"
                    @click.stop="addNewActiveExportInvoiceTransportRow"
                >
                    <v-icon>add</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment/moment";

export default {
    name: "transport-edit-tab",
    data() {
        return {
            mountedLoaded: false,
            termsOfDeliveryItems: [
                {
                    title: "EXW",
                    value: "EXW"
                },
                {
                    title: "CIF",
                    value: "CIF"
                },
                {
                    title: "FOB",
                    value: "FOB"
                }
            ],
            cargoTypeItems: [
                {
                    title: "20”",
                    value: "20"
                },
                {
                    title: "20” reefer",
                    value: "20_reefer"
                },
                {
                    title: "40”",
                    value: "40"
                },
                {
                    title: "40” reefer",
                    value: "40_reefer"
                },
                {
                    title: "Rekka 2,7m kõrge",
                    value: "truck_height_2.7m"
                },
                {
                    title: "Rekka 2-2,5m kõrge",
                    value: "truck_height_2-2.5m"
                }
            ]
        };
    },
    mounted() {
        setTimeout(() => {
            this.mountedLoaded = true;
            console.log(this.mountedLoaded);
        }, 100);
    },
    methods: {
        ...mapMutations("ExportSaleInvoiceStore", [
            "updateActiveExportInvoiceTransportProperty",
            "addNewActiveExportInvoiceTransportRow",
            "removeActiveExportInvoiceTransportRow"
        ]),
        updateTransportField(value, field, index) {
            this.updateActiveExportInvoiceTransportProperty({ prop: field, value: value, index: index });
        },

        formatDate(value) {
            if (value) {
                return moment(value).format("DD.MM.YYYY");
            }

            return "-";
        }
    },
    computed: {
        ...mapState(["clients", "users"]),
        ...mapState("ExportSaleInvoiceStore", ["activeExportInvoice"])
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
.col-item {
    padding: 0 !important;
}
::v-deep .t-spacing > .v-input__control > .v-input__slot {
    min-height: 9px !important;
}
::v-deep .t-spacing .v-input__icon {
    padding-bottom: 8px;
}
::v-deep button.fa-times-circle {
    font-size: 14px;
}
::v-deep .payroll-date {
    border: 1px solid rgba(96, 96, 96, 0.32) !important;
    border-radius: 6px !important;
    padding: 2px !important;
    padding-left: 10px !important;
    font-size: 16px !important;
    height: 30px;
}
::v-deep .vue-monthly-picker .vmp-input-append {
    padding: 3px !important;
}
::v-deep .flexbox {
    color: black;
    font-weight: bolder;
}
</style>
